<template>
  <div class="page contact-page">
    <section class="contact-hero">
      <div class="hero-copy">
        <h1>Contact Us <span>Now</span></h1>
        <p>Have questions or need a custom solution for your POD business?</p>
        <p>Our team is ready to help you build, grow and scale with confidence.</p>
        <div class="contact-benefits">
          <IconCard icon="24" title="Fast Response" text="Within 24 Hours" compact />
          <IconCard icon="Q" title="Reliable Support" text="From Real People" compact />
          <IconCard icon="P" title="POD Experts" text="End-to-End Service" compact />
        </div>
      </div>
      <FactoryVisual variant="contact-map">
        <div class="right_img_box">
          <img src="@/assets/img/company.png" alt="Factory Visual" />
        </div>
      </FactoryVisual>
    </section>

    <section class="contact-grid">
      <article class="contact-card card">
        <h2>Get In Touch</h2>
        <p>We're here to help! Reach out to us through any of the channels below.</p>
        <div v-for="item in contactItems" :key="item.title" class="contact-line">
          <div class="icon-bubble">{{ item.icon }}</div>
          <div>
            <strong>{{ item.title }}</strong>
            <span>{{ item.text }}</span>
          </div>
        </div>
      </article>

      <form class="message-form card" @submit.prevent="submitForm">
        <h2>Send Us a Message</h2>
        <p>Fill out the form below and we'll get back to you as soon as possible.</p>
        <label>
          Your Name
          <input v-model.trim="form.name" type="text" placeholder="Your Name" required>
        </label>
        <label>
          Your Email
          <input v-model.trim="form.email" type="email" placeholder="Your Email" required>
        </label>
         <label>
          Your subject
          <input v-model.trim="form.subject" type="text" placeholder="Your subject" required>
        </label>
        <label>
          Your Message
          <textarea v-model.trim="form.message" placeholder="Your Message" rows="5" required></textarea>
        </label>
        <button class="primary-button full" type="submit">Submit</button>
        <small class="privacy">Lock: We respect your privacy. Your information is safe with us.</small>
        <strong v-if="submitted" class="success-message">Thanks. Your message is ready to send.</strong>
      </form>
    </section>

    <CtaBanner title="Start Your Custom POD Order Today"
      text="Talk directly with our fulfillment team and receive a tailored solution for your store."
      secondary="Talk To Our Team" products />
  </div>
</template>

<script>
import CtaBanner from '@/components/CtaBanner.vue';
import FactoryVisual from '@/components/FactoryVisual.vue';
import IconCard from '@/components/IconCard.vue';
export default {
  name: 'Contact',
  components: {
    CtaBanner,
    FactoryVisual,
    IconCard,
  },
  data() {
    return {
      submitted: false,
      form: {
        name: '',
        email: '',
        message: '',
        subject: '', // 用于存储表单提交的subject字段
      },
      contactItems: [
        { icon: '📦', title: 'Email', text: 'support@srfulfill.com' },
        { icon: '⏱', title: 'WhatsApp', text: '+86 178 9844 9604' },
        { icon: '🛡️', title: 'Office Address', text: 'Longgang District, Shenzhen, China' },
        { icon: '🌐', title: 'We Support', text: 'Shopify / Etsy / Amazon / eBay / TikTok Shop and more' }
      ],
      rules: {
        name: [{ required: true, message: "Enter your name", trigger: "blur" }],
        subject: [{ required: true, message: "Subject is required", trigger: "blur" }],
        message: [{ required: true, message: "Content is required", trigger: "blur" }],
        email: [
          {
            required: true,
            message: "Enter email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Enter correct email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      let form = {
        username: this.form.name,
        email: this.form.email,
        subject: this.form.subject,
        message: this.form.message,
      };
      this.http
        .fetchPost(this.api.contact_us, form)
        .then((res) => {
          // console.log(res,'5555')
          if (res.data.code === 200) {
            this.$message.success("success");
          } else {
            this.$message.error("error");
          }
          // 请求成功处理
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
